import type { BrandContentAlign, BrandSpacing } from '$lib/types/Theme';

// SYNC: mirrors perspective-app-next/modules/app/brands/helpers/resolveStyleClasses.ts
// with the funnel-app `fun-` Tailwind prefix applied.

export const getPaddingX = (value: BrandSpacing): string | undefined =>
    ({
        xs: 'fun-px-1',
        sm: 'fun-px-2',
        md: 'fun-px-4',
        lg: 'fun-px-6',
        xl: 'fun-px-8',
        '2xl': 'fun-px-12',
        '3xl': 'fun-px-16',
    })[value];

export const getPaddingY = (value: BrandSpacing): string | undefined =>
    ({
        xs: 'fun-py-1',
        sm: 'fun-py-2',
        md: 'fun-py-4',
        lg: 'fun-py-6',
        xl: 'fun-py-8',
        '2xl': 'fun-py-12',
        '3xl': 'fun-py-16',
    })[value];

export const getBlockGap = (value: BrandSpacing): string | undefined =>
    ({
        xs: 'fun-gap-y-1',
        sm: 'fun-gap-y-2',
        md: 'fun-gap-y-3',
        lg: 'fun-gap-y-4',
        xl: 'fun-gap-y-5',
        '2xl': 'fun-gap-y-6',
        '3xl': 'fun-gap-y-7',
    })[value];

export const getBlockGapX = (value: BrandSpacing): string | undefined =>
    ({
        xs: 'fun-gap-x-1',
        sm: 'fun-gap-x-2',
        md: 'fun-gap-x-3',
        lg: 'fun-gap-x-4',
        xl: 'fun-gap-x-5',
        '2xl': 'fun-gap-x-6',
        '3xl': 'fun-gap-x-7',
    })[value];

export const getContentAlign = (value: BrandContentAlign): string | undefined =>
    ({
        left: 'fun-items-start',
        center: 'fun-items-center',
        right: 'fun-items-end',
    })[value];
